const generateAvatar = async ({ selectedImage, prompt, gender }) => {
  const myHeaders = new Headers();
  myHeaders.append(
    "Authorization",
    "token cd000db8b22d3d70b6e6ef02c2ab23132579445e",
  );

  const formdata = new FormData();
  formdata.append("face_image", selectedImage, `${selectedImage.name}`); // Correct file handling
  formdata.append("prompt", prompt);
  formdata.append("img_count", "1");
  formdata.append("id_mix", "false");
  formdata.append("scale", "1.2");
  formdata.append("id_scale", "0.8");
  formdata.append("mode", "fidelity");
  formdata.append("image_height", "1024");
  formdata.append("image_width", "768");

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: formdata,
    redirect: "follow",
  };

  try {
    const response = await fetch(
      "https://pulid.cognise.art/api/avatar_generation_v2/",
      requestOptions,
    );
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const result = await response.json();
    return result;
  } catch (error) {
    console.error("Error creating avatar:", error.message);
    throw error;
  }
};

const createAvatar = async (data) => {
  const myHeaders = new Headers();
  myHeaders.append(
    "Authorization",
    "token 7b2203b5edac2d80c090f202158630e7abe4e779",
  );
  const formdata = new FormData();
  formdata.append("name", data?.name);
  formdata.append("prompt", data?.prompt);
  formdata.append("thumbnail", data.thumbnailImg, data.thumbnailImg.name);
  formdata.append("is_premium", data?.is_premium);

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: formdata,
    redirect: "follow",
  };

  try {
    const response = await fetch(
      `https://pulid.cognise.art/api/add_style/`,
      requestOptions,
    );
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const result = await response.text();
    return result;
  } catch (error) {
    console.error("Error creating avatar:", error.message);
    throw error;
  }
};

export { generateAvatar, createAvatar };
